export default {"id":"icon-empty-tasks"}